import type { StrategicIntensity } from '@/hooks/useStrategicStream';

export const WORKSTREAM_COLORS = [
  { border: 'rgba(34, 197, 94, 0.3)', bg: 'rgba(34, 197, 94, 0.1)', text: '#4ade80' },
  { border: 'rgba(251, 146, 60, 0.3)', bg: 'rgba(251, 146, 60, 0.1)', text: '#fb923c' },
  { border: 'rgba(96, 165, 250, 0.3)', bg: 'rgba(96, 165, 250, 0.1)', text: '#60a5fa' },
  { border: 'rgba(168, 85, 247, 0.3)', bg: 'rgba(168, 85, 247, 0.1)', text: '#c4b5fd' },
  { border: 'rgba(250, 204, 21, 0.3)', bg: 'rgba(250, 204, 21, 0.1)', text: '#facc15' },
];

export const INTENSITY_CONFIGS: Record<StrategicIntensity, { label: string; workstreams: string; debaters: number }> = {
  fast: { label: 'Fast', workstreams: '3', debaters: 2 },
  deep: { label: 'Deep', workstreams: '4', debaters: 3 },
};
